var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHands4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 140,
    viewBox: "0 0 352 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6777 101.04C24.7056 103.061 15.517 99.1376 12.0713 96.9485C9.40332 95.2618 8.48207 93.0728 9.77421 90.4411C11.6526 86.6969 17.4672 87.0558 18.6756 87.295",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8892 92.4629C23.1938 93.0444 25.4436 93.825 27.6131 94.7959",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1094 96.3267C5.82621 98.5755 8.06352 102.164 9.54709 103.899C12.586 107.487 22.4445 110.298 26.5243 110.43C27.16 110.433 27.7852 110.268 28.3359 109.951C28.8867 109.633 29.3433 109.175 29.659 108.624C29.9758 108.095 30.0863 107.469 29.9692 106.864C29.8522 106.259 29.5159 105.718 29.0249 105.346",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60179 103.432C5.61073 105.825 7.40537 109.485 9.95375 111.554C14.2489 115.143 20.4225 115.753 23.5691 115.526C25.1005 115.418 28.283 113.899 27.1583 110.813",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.57 39.0518C102.916 62.9761 84.2397 88.0966 50.1775 85.8118C50.1775 85.8118 14.2848 73.1319 4.2947 74.4717C3.21792 74.6152 1.50703 75.1296 1.21989 76.1703C0.705429 77.8331 0.872928 78.6226 4.17506 81.1825C9.03254 84.9386 30.3169 90.6326 34.0856 91.4579",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9819 113.504C124.2 142.919 156.647 46.7433 164.615 21.9937",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7937 88.5273C40.1277 88.5273 28.63 93.9103 26.4765 95.8003C23.7725 98.1928 26.309 101.028 29.7906 101.076C33.3449 100.891 36.8248 99.9876 40.02 98.42C41.0728 97.6305 36.5982 103.779 39.1227 107.99",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.519 0.99707C266.611 9.60578 222.968 59.4457 246.344 105.636C254.954 122.69 272.452 131.928 288.602 136.093C319.254 143.985 336.915 133.664 342.076 128.894",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M322.514 100.488C319.626 100.554 316.774 101.138 314.093 102.212C308.768 104.302 294.229 104.629 285.732 95.1393C266.522 73.7433 293.196 44.0911 325.573 40.8691",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M320.01 108.493C326.958 111.966 340.377 108.984 347.074 109.927C349.378 110.242 350.284 111.073 350.599 112.243C351.417 115.276 336.311 118.247 325.297 115.629",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M348.874 116.246C350.548 119.279 343.838 122.085 338.64 122.539C334.39 122.641 330.138 122.461 325.913 121.997",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M346.835 122.727C346.432 123.243 343.826 126.264 337.243 127.761C333.413 128.598 329.491 128.94 325.574 128.781",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands4);
export default __webpack_public_path__ + "static/media/hands4.84a453ac5625352683c9cd76b4b7e73a.svg";
export { ForwardRef as ReactComponent };